import React, { useState } from "react";
import { Input } from 'antd';
import { Search } from "lucide-react";

const prefix = <Search className="absolute left-3 text-slate-500 w-4 h-4 mr-2"/>;

function SearchFilter(props) {
	const { placeholder, searchHandler, filters, pagination } = props;
	const [value, setValue] = useState("");

	const onSearchHandler = (value) => {
		searchHandler({
			...(filters || {}),
			page: 1,
			paginate: pagination?.per_page || 10, 
			keyword: value
		});
	};
		
	return (
		<div className="w-full">
			<div className="relative flex items-center w-full rounded-lg border-2 border-gray-50 
							dark:border dark:border-gray-200  bg-gray-50 dark:bg-white/30
							focus-within:border-emerald-500 focus-within:ring-emerald-500/50  
							focus-within:ring-2 focus-within:outline-none h-9 "
			>
				<Input
					placeholder={placeholder ?? "Keyword"}
					value={value}
					onChange={(e) => {
                        const val = e.target.value;
                        setValue(val);

                        if (val === "") {
                            onSearchHandler(""); 
                        }
                    }}
					onPressEnter={() => onSearchHandler(value)}
					allowClear
					variant="borderless"
					prefix={prefix}
					className="
						pl-9 sm:pl-10
						pr-3
						text-[13px] sm:text-[14px] 
						disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50
					"
				/>
			</div>
		</div>
	);
}

export default SearchFilter;
